<template>
    <div class="layout">
        <div class="layout__header">
            <div class="layout__title">
                <h3>Informe de Comisiones de Retornos e Incobrables</h3>
            </div>
            <div class="layout__controls">
                <div class="form-inline">
                    <button @click="consultar" class="btn-info btn--bigger">
                        <i class="fa fa-search"></i><span>Consultar</span>
                    </button>
                    <button @click="exportar" class="btn-success btn--bigger">
                        <i class="fa fa-file-excel-o"></i><span>Exportar</span>
                    </button>
                </div>
            </div>
        </div>
        <div class="card">
            <div class="card__title">
                <h5>Información de la consulta</h5>
            </div>
            <div class="card__content">
                <div class="row">
                    <div class="col-xs-12 col-md-4">
                        <div class="form-field select2">
                            <div class="select2-field">
                                <v-select
                                placeholder="Seleccione..."
                                id="vendedor_id"
                                v-model="selectedVendedores"
                                :options="vendedores"
                                @input="inputVendedores"
                                @search="searchVendedores"
                                label="descripcion"
                                ></v-select>
                                <label for="vendedor_id">Vendedor</label>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-12 col-md-4">
                        <div class="form-field select">
                            <div class="select-field">
                                <select name="tipo_fecha" id="tipo_fecha" v-model="form.tipo_fecha">
                                    <option value="H">Hoy</option>
                                    <option value="A">Ayer</option>
                                    <option value="P">Personalizada</option>
                                </select>
                                <label for="fecha">Fecha</label>
                            </div>
                        </div>
                    </div>
                    <div v-show="form.tipo_fecha === 'P'" class="col-xs-12 col-md-4">
                        <div class="form-field">
                            <div class="datepicker-field">
                                <VueCtkDateTimePicker
                                id="desde"
                                v-model="form.desde"
                                locale="es"
                                only-date
                                no-label
                                button-now-translation="Ahora"
                                format="YYYY-MM-DD"
                                formatted="YYYY-MM-DD"
                                label="Seleccione fecha..."
                                />
                                <label>Desde</label>
                            </div>
                        </div>
                    </div>
                    <div v-show="form.tipo_fecha === 'P'" class="col-xs-12 col-md-4">
                        <div class="form-field">
                            <div class="datepicker-field">
                                <VueCtkDateTimePicker
                                id="hasta"
                                v-model="form.hasta"
                                locale="es"
                                only-date
                                no-label
                                button-now-translation="Ahora"
                                format="YYYY-MM-DD"
                                formatted="YYYY-MM-DD"
                                label="Seleccione fecha..."
                                />
                                <label>Hasta</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card">
            <div class="card__title">
                <h5>Resultados de la Consulta</h5>
            </div>
            <div class="card__content">
                <vs-table
                    ref="tableSelect"
                    search
                    :max-items="maximoItems == ''?20:maximoItems"
                    :data="registros"
                    pagination
                >
                    <template slot="header">
                    <div class="form-inline">
                        <input-field  
                        class="input-field--stretch ml-3"
                        type="tel" 
                        v-mask="'###'"
                        v-model="maximoItems"
                        id="maximoItems"
                        placeholder
                        >
                            <span>Cantidad de registros:</span>
                        </input-field>
                    </div>
                    </template>
                    <template slot="thead">
                        <vs-th
                            :sort-key="columna.sortable?columna.nombre:null"
                            v-for="columna in columnas"
                            v-show="!columna.hidden"
                            :key="columna.nombre"
                        >
                            {{ columna.descripcion }}
                        </vs-th>
                    </template>
                    <template slot-scope="{ data }">
                        <vs-tr
                            :data="tr"
                            :key="index"
                            v-for="(tr, index) in data"
                        >
                            <vs-td v-show="!columna.hidden" :data="lodash.get(data[index], columna.nombre)" v-for="columna in columnas" :key="columna.nombre + index">
                                <span>
                                    {{ columna.money?moneyFormat(lodash.get(data[index], columna.nombre)):lodash.get(data[index], columna.nombre) }}
                                </span>
                            </vs-td>
                        </vs-tr>
                    </template>
                </vs-table>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data: function () {
        return {
            moneyFormat: moneyFormat,
            lodash: _,
            maximoItems: 20,
            buttons: [],
            form: {
                tipo_fecha: 'H',
                desde: moment(new Date()).format('YYYY-MM-DD'),
                hasta: moment(new Date()).format('YYYY-MM-DD'),
                vendedores_id:  [],
                tipo_consulta: 'N'
            },
            selectedVendedores: [],
            path: url + '/consulta-liquidaciones-venta',
            vendedores: [],
            registros: [],
            columnas: [
                {
                    nombre: 'numero_documento',
                    descripcion: '# Cartilla'
                },
                {
                    nombre: 'cliente.descripcion',
                    descripcion: 'Cliente'
                },
                {
                    nombre: 'fecha',
                    descripcion: 'Fecha'
                },
                {
                    nombre: 'valor_total',
                    descripcion: 'Valor total'
                },
                {
                    nombre: 'saldo_total',
                    descripcion: 'Saldo'
                },
                {
                    nombre: 'saldo_incobrable',
                    descripcion: 'Saldo Incobrable'
                },
                {
                    nombre: 'saldo_retorno',
                    descripcion: 'Saldo Retorno'
                }
            ]
        };
    },
    methods: {
        exportar: function () {
            this.form.tipo_consulta = 'E';
            window.open(url + '/informe-comisiones-retorno-incobrables' + this.serialize(this.form), '_blank');
        },
        serialize: function (obj) {
            return (
                "?" +
                Object.keys(obj)
                .reduce(function (a, k) {
                    let val = obj[k];
                    let esArray = false;
                    if (val instanceof Date) {
                    val = val.toLocaleDateString("en");
                    } else if (val instanceof Array) {
                    esArray = true;
                    let acumulador = "";
                    for (let i = 0; i < val.length; i++) {
                        acumulador += k + "%5B%5D=" + val[i];
                        if (i != val.length - 1) {
                        acumulador += "&";
                        }
                    }
                    val = acumulador;
                    a.push(val);
                    }
                    if (!esArray) a.push(k + "=" + encodeURIComponent(val));
                    return a;
                }, [])
                .join("&")
            );
        },
        consultar: function () {
            this.form.tipo_consulta = 'N';
            axios.get(url + '/informe-comisiones-retorno-incobrables', {
                params: this.form
            }).then(({data}) => {
                this.registros = data;
            }).catch(() => {
                swal('Hubo un error, intente nuevamente.', 'Error', 'error');
            });
        },
        searchVendedores: function (search, loading) {
            loading(true);
            let that = this;
            let xmlhttp = new XMLHttpRequest();
            xmlhttp.onreadystatechange = function () {
                if (
                (this.readyState == 4 && this.status == 200) ||
                this.status == 201
                ) {
                let json = JSON.parse(this.responseText);
                that.vendedores = json;
                loading(false);
                } else loading(false);
            };
            xmlhttp.open("GET", url + "/search/vendedores?search=" + search, true);
            xmlhttp.send();
        },
        inputVendedores: function () {
            this.form.vendedores_id.splice(0, this.form.vendedores_id.length);
            for (let i = 0; i < this.selectedVendedores.length; i++) {
                this.form.vendedores_id.push(this.selectedVendedores[i].id);
            }
        }
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/nomina/InformeComisiones.vue